// Mutations
export const SET_LINKS_EXTERNOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.linksExternos.data = payload
    state.linksExternos.lastUpdate = new Date()
  }
}
export const ADD_LINKS_EXTERNOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.linksExternos.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.linksExternos.data.push(data)
      }
    })
  }
}
export const SET_LINKS_EXTERNOS_LOADING = (state, payload) => {
  state.linksExternos.loading = payload
}

